import { useTranslation } from 'react-i18next';
import type { FileState } from '../../lib/types.ts';
import { isFreed, shortDate } from './format.ts';

interface Props {
  file: FileState;
  /** 'player' — большая заглушка на карточке; 'thumb' — 64×38 в таблице. */
  variant?: 'player' | 'thumb';
}

/**
 * Диагональная штриховка вместо «сломанного видео» — файл был и его освободили.
 *
 * Рисуется ТОЛЬКО при status='freed'. При 'absent' (клип ещё не отрендерен,
 * фильм качается) возвращает null: это не потеря, и вызывающий показывает
 * обычное «нет превью / рендерится».
 */
export function MediaPlaceholder({ file, variant = 'player' }: Props) {
  const { t } = useTranslation();
  if (!isFreed(file)) return null;

  if (variant === 'thumb') {
    return <div className="thumb gone" title={t('archive.file.freed', { date: shortDate(file.freedAt) })} />;
  }
  return (
    <div className="player gone">{t('archive.file.freed', { date: shortDate(file.freedAt) })}</div>
  );
}
